import { useHeaderContext } from '@jouzen/ecom-components/layout';

import CarouselImages from '@/app/[locale]/product/_steps/CarouselImages';
import ChargerModelStepImage from '@/app/[locale]/product/_steps/ChargerModelStepImage';
import WizStepId from '@/app/[locale]/product/_steps/enums/WizStepId';
import FinishStepImage from '@/app/[locale]/product/_steps/FinishStepImage';
import SizeStepImage from '@/app/[locale]/product/_steps/SizeStepImage';

interface LayoutImageProps {
  readonly currentStep: WizStepId | undefined;
  readonly isAccessory: boolean;
}

const LayoutImage = ({ currentStep, isAccessory }: LayoutImageProps) => {
  const headerContext = useHeaderContext();
  const setInverse = headerContext?.setInverse;
  switch (currentStep) {
    case WizStepId.Finish:
      return <FinishStepImage />;
    case !isAccessory && WizStepId.Size:
      return <SizeStepImage />;
    case WizStepId.Accessory:
      return <ChargerModelStepImage />;
    default:
      return <CarouselImages setInverse={setInverse} />;
  }
};

export default LayoutImage;
